// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__f_J4I","title":"ClientReferral_title__3qaOe","itemText":"ClientReferral_itemText__kC64q"};